import React from "react";
import MatchComparisonProgressBar2 from "./MatchComparisonProgressBar2.js";
import classes from "./MatchStats2.module.css";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const STATS = [
    { label: "Total Shots", homePct: "homeTeamTotalShotsPer", awayPct: "awayTeamTotalShotsPer", homeVal: "homeTeamTotalShots", awayVal: "awayTeamTotalShots" },
    { label: "Shots On Goal", homePct: "homeTeamShotsOnGoalPer", awayPct: "awayTeamShotsOnGoalPer", homeVal: "homeTeamShotsOnGoal", awayVal: "awayTeamShotsOnGoal" },
    { label: "Shots Off Goal", homePct: "homeTeamShotsOffGoalPer", awayPct: "awayTeamShotsOffGoalPer", homeVal: "homeTeamShotsOffGoal", awayVal: "awayTeamShotsOffGoal" },
    { label: "Fouls", homePct: "homeTeamFoulsPer", awayPct: "awayTeamFoulsPer", homeVal: "homeTeamFouls", awayVal: "awayTeamFouls" },
    { label: "Corner Kicks", homePct: "homeTeamCornerPer", awayPct: "awayTeamCornerPer", homeVal: "homeTeamCorner", awayVal: "awayTeamCorner" },
    { label: "Offsides", homePct: "homeTeamOffsidesPer", awayPct: "awayTeamOffsidesPer", homeVal: "homeTeamOffsides", awayVal: "awayTeamOffsides" },
    { label: "Yellow Cards", homePct: "homeTeamYellowCardPer", awayPct: "awayTeamYellowCardPer", homeVal: "homeTeamYellowCard", awayVal: "awayTeamYellowCard" },
    { label: "Red Cards", homePct: "homeTeamRedCardPer", awayPct: "awayTeamRedCardPer", homeVal: "homeTeamRedCard", awayVal: "awayTeamRedCard" },
    { label: "Ball Possession", homePct: null, awayPct: null, homeVal: "homeTeamPossession", awayVal: "awayTeamPossession", possession: true },
    { label: "Passes", homePct: "homeTeamPassesPer", awayPct: "awayTeamPassesPer", homeVal: "homeTeamPasses", awayVal: "awayTeamPasses" },
];

const STATS_FR = [
    { label: "Nombre total de tirs", homePct: "homeTeamTotalShotsPer", awayPct: "awayTeamTotalShotsPer", homeVal: "homeTeamTotalShots", awayVal: "awayTeamTotalShots" },
    { label: "Tirs au but", homePct: "homeTeamShotsOnGoalPer", awayPct: "awayTeamShotsOnGoalPer", homeVal: "homeTeamShotsOnGoal", awayVal: "awayTeamShotsOnGoal" },
    { label: "Tirs hors but", homePct: "homeTeamShotsOffGoalPer", awayPct: "awayTeamShotsOffGoalPer", homeVal: "homeTeamShotsOffGoal", awayVal: "awayTeamShotsOffGoal" },
    { label: "Fautes", homePct: "homeTeamFoulsPer", awayPct: "awayTeamFoulsPer", homeVal: "homeTeamFouls", awayVal: "awayTeamFouls" },
    { label: "Coups de pied de coin", homePct: "homeTeamCornerPer", awayPct: "awayTeamCornerPer", homeVal: "homeTeamCorner", awayVal: "awayTeamCorner" },
    { label: "Hors-jeu", homePct: "homeTeamOffsidesPer", awayPct: "awayTeamOffsidesPer", homeVal: "homeTeamOffsides", awayVal: "awayTeamOffsides" },
    { label: "Cartons jaunes", homePct: "homeTeamYellowCardPer", awayPct: "awayTeamYellowCardPer", homeVal: "homeTeamYellowCard", awayVal: "awayTeamYellowCard" },
    { label: "Cartons rouges", homePct: "homeTeamRedCardPer", awayPct: "awayTeamRedCardPer", homeVal: "homeTeamRedCard", awayVal: "awayTeamRedCard" },
    { label: "Possession du ballon", homePct: null, awayPct: null, homeVal: "homeTeamPossession", awayVal: "awayTeamPossession", possession: true },
    { label: "Laissez-passer", homePct: "homeTeamPassesPer", awayPct: "awayTeamPassesPer", homeVal: "homeTeamPasses", awayVal: "awayTeamPasses" },
];

const MatchStats2 = ({ teamStatistics }) => {
    const { t } = useTranslation();
    const { selectedLanguage } = useSelector((state) => state.languageSlice);
    if (!teamStatistics) return null;
    return (
        <div className={classes.stats_container}>
            {/* Header with team logos */}
            <div className={classes.teams_info}>
                <div className={classes.home_team_container}>
                    <img src={teamStatistics?.homeTeamLogo} className={classes.team_logo} alt={teamStatistics?.homeTeamName} />
                    <p className={classes.name}>{teamStatistics?.homeTeamName}</p>
                </div>
                <div className={classes.away_team_container}>
                    <img src={teamStatistics?.awayTeamLogo} className={classes.team_logo} alt={teamStatistics?.awayTeamName} />
                    <p className={classes.name}>{teamStatistics?.awayTeamName}</p>
                </div>
            </div>

            {/* Stat rows */}
            <div className={classes.stats_sub_container}>
                {selectedLanguage == 0 ? STATS.map(({ label, homePct, awayPct, homeVal, awayVal, possession }) => {
                    const v1 = teamStatistics?.[homeVal] ?? 0;
                    const v2 = teamStatistics?.[awayVal] ?? 0;
                    const p1 = possession
                        ? String(v1).replace("%", "")
                        : (teamStatistics?.[homePct] ?? 0);
                    const p2 = possession
                        ? String(v2).replace("%", "")
                        : (teamStatistics?.[awayPct] ?? 0);

                    return (
                        <MatchComparisonProgressBar2
                            key={label}
                            name={label}
                            percentage1={p1}
                            percentage2={p2}
                            value1={v1 != null ? v1 : 0}
                            value2={v2 != null ? v2 : 0}
                        />
                    );
                }) : (
                    STATS_FR.map(({ label, homePct, awayPct, homeVal, awayVal, possession }) => {
                        const v1 = teamStatistics?.[homeVal] ?? 0;
                        const v2 = teamStatistics?.[awayVal] ?? 0;
                        const p1 = possession
                            ? String(v1).replace("%", "")
                            : (teamStatistics?.[homePct] ?? 0);
                        const p2 = possession
                            ? String(v2).replace("%", "")
                            : (teamStatistics?.[awayPct] ?? 0);

                        return (
                            <MatchComparisonProgressBar2
                                key={label}
                                name={label}
                                percentage1={p1}
                                percentage2={p2}
                                value1={v1 != null ? v1 : 0}
                                value2={v2 != null ? v2 : 0}
                            />
                        );
                    })
                )}
            </div>
        </div>
    );
};

export default MatchStats2;